import { useState, CSSProperties } from 'react';
import cn from 'classnames';
import MarkdownCopy from '@components/cms/Slices/MarkdownCopy';
import Heading from '@components/ui/Heading';
import Tooltip from '@components/ui/Tooltip';

import styles from './ToolTipsOverlay.module.scss';

export interface ITooltip {
  position: {
    x: number;
    y: number;
  };
  title?: string;
  body?: string;
}

const ToolTipBody = ({ title, body }: { title?: string; body: any }) => (
  <>
    {title && (
      <Heading semanticLevel="h3" styleLevel="6">
        {title}
      </Heading>
    )}
    {body && <MarkdownCopy text={body} />}
  </>
);

const ToolTipsOverlay = ({
  tooltips = [],
  children,
}: {
  tooltips?: ITooltip[];
  children: React.ReactNode;
}) => {
  const [activeToolTip, setActiveToolTip] = useState<{ [x: string]: boolean }>(
    {}
  );

  return (
    <div style={{ position: 'relative', height: '100%', width: '100%' }}>
      {children}

      {tooltips
        .sort((a, b) => a.position.y - b.position.y)
        .map(({ title, body, position }, i) => {
          const positionCSS = {
            '--positionX': `${position.x}%`,
            '--positionY': `${position.y}%`,
          } as CSSProperties;
          const tooltipId = `tooltip-${i}`;

          return (
            <div
              key={`${position.x}-${position.y}`}
              style={positionCSS}
              className={cn(styles.toolTipWrapper, {
                [styles.toolTipActive]: activeToolTip[tooltipId],
              })}
            >
              <Tooltip
                tooltipContents={<ToolTipBody title={title} body={body} />}
                tooltipId={tooltipId}
                popoverClasses={styles.toolTipBody}
                toggleCallback={(toolTip) => setActiveToolTip(toolTip)}
                displayCloseButton
              />
            </div>
          );
        })}
    </div>
  );
};

export default ToolTipsOverlay;
